import { graphql } from '@guuru/graphql-common/gql';

export default graphql(`
  fragment CommunityExpertFragment on CommunityExpert {
    id
    externalId
    bio
    photoUrl
    name
    joinedAt
    rating
    moments {
      id
      url
    }
  }
`);
